import { useLazyGetRecordingQuery } from '@carboncopyco/data';
import {
  type IGlobalTab,
  TabGroupName,
  TabType,
} from '@carboncopyco/types/desktop';
import { getGroupDefaultValue } from '../../../util/tab-util';
import type { ICreateGlobalTabData } from '../../services/TabManager';

export const useClonePreview = () => {
  const [getRecording] = useLazyGetRecordingQuery();

  return async ({
    cloneId,
    activeOrganization,
    createGlobalTab,
  }: {
    cloneId: string;
    activeOrganization: { id: string };
    createGlobalTab: (globalTabData: ICreateGlobalTabData) => IGlobalTab;
  }) => {
    try {
      const clone = await getRecording({
        organizationId: activeOrganization.id,
        id: cloneId,
      }).unwrap();

      const url = decodeURIComponent(clone.firstUrl);
      createGlobalTab({
        type: TabType.PREVIEW_CLONE,
        url,
        cloneId: clone.id.toString(),
        payload: clone, // TODO: set payload: { clone } to align the payload structure
        group: getGroupDefaultValue(
          Number(clone.id),
          TabGroupName.ClonePreview
        ),
      });
    } catch (error) {
      console.error('Error opening in preview', error);
    }
  };
};
